import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const AppLogo = forwardRef(({
    src,
    alt = 'Logo',
    width = 'auto',
    height = 'auto',
    maxWidth,
    maxHeight,
    onClick,
    hoverEffect = false,
    grayscale = false,
    preserveAspectRatio = true,
    sx = {},
    loading = 'lazy',
    ...props
}, ref) => {
    const logoStyles = {
        width,
        height,
        maxWidth,
        maxHeight,
        transition: 'all 0.3s ease',
        filter: grayscale ? 'grayscale(100%)' : 'none',
        objectFit: preserveAspectRatio ? 'contain' : 'fill',
        '&:hover': hoverEffect ? {
            transform: 'scale(1.05)',
            filter: 'none',
            cursor: onClick ? 'pointer' : 'default'
        } : {},
        ...sx
    };

    return (
        <Box
            ref={ref}
            component="img"
            src={src}
            alt={alt}
            loading={loading}
            sx={logoStyles}
            onClick={onClick}
            {...props}
        />
    );
});

AppLogo.propTypes = {
    src: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    alt: PropTypes.string,
    width: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    height: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    maxWidth: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    maxHeight: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string
    ]),
    onClick: PropTypes.func,
    hoverEffect: PropTypes.bool,
    grayscale: PropTypes.bool,
    preserveAspectRatio: PropTypes.bool,
    sx: PropTypes.object,
    loading: PropTypes.oneOf(['eager', 'lazy'])
};

export default AppLogo;